module.exports = __webpack_public_path__ + "static/media/S8.a8c0c124.webp";